import { connect } from "react-redux";
import KpisList from "./KpisList";

import { init, getReferentielsList, setMatchReferentiel } from "./../../../redux/actions/referentielsActions"
const mapStateToProps = (state) => {
	return {
		kpisList: state.kpis.kpisList,
		page: state.kpis.page,
		pages: state.kpis.pages,
		pageSize: state.kpis.pageSize,
		nbItems: state.kpis.kpisList.length,
		currentClientId: state.currentClient.id,
		match: state.kpis.match,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		init: sectionName => dispatch(init(sectionName)),
		getNext: page => {
			const nextPage = page;
			dispatch(getReferentielsList({ page: nextPage }, "kpis"));
		},
		setMatchFilters: filters => {
			dispatch(setMatchReferentiel(filters, "kpis"));
		}
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(KpisList);


// WEBPACK FOOTER //
// src/containers/admin/kpis/KpisContainer.js